import React from 'react';

import { Contain } from './styles';

export default ({ children, ...rest }) => {
  return (
    <Contain {...rest}>
      {children}
    </Contain>
  )
}
